var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "home" } },
    [
      _c("ui-header", {
        attrs: {
          "nav-num": -1,
          "user-info": _vm.userInfo,
          nav: _vm.nav,
          "login-url": _vm.loginUrl,
          "logout-url": _vm.logoutUrl,
          "home-url": _vm.homeUrl,
          "register-url": _vm.registerUrl,
          "ucenter-url": _vm.ucenterUrl
        }
      }),
      _vm._v(" "),
      _c("div", { staticClass: "main" }, [
        _c("div", { staticClass: "go-back" }, [
          _c("p", { staticClass: "go-back-title" }, [
            _vm._v("该网址不存在，去首页看看吧")
          ]),
          _vm._v(" "),
          _c(
            "a",
            { staticClass: "go-back-btn", attrs: { href: _vm.homeUrl } },
            [_vm._v("返回首页")]
          )
        ]),
        _vm._v(" "),
        _c("img", {
          staticClass: "not-found-img",
          attrs: { src: _vm.notFound }
        })
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4e5e4170", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4e5e4170","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/notFound/Home.vue
// module id = 25
// module chunks = 0